import React, { useEffect } from 'react';
import UnsubForm from '../components/Unsubscribe/UnsubForm';
import { userEvents } from '../utils/analytics';
import './Unsubscribe.css';

const Unsubscribe = () => {
  useEffect(() => {
    userEvents.pageView('unsubscribe', { type: 'newsletter' });
  }, []);

  return (
    <div className="unsubscribe">
        <UnsubForm />
      </div>
  );
};

export default Unsubscribe;
